import { createPortal } from 'react-dom';

const Portal = ({ children, container }: { children: any; container: string }) => {
  if (document.getElementById(container)) {
    // @ts-ignore
    return createPortal(children, document.getElementById(container));
  }
  return null;
};

export default Portal;
